<template>
    <label class="ds-employees-search">
        <icon width="14" height="14" vb-size="16" class="ds-employees-search-icon"><IconSearch /></icon>
        <input type="text"
            class="ds-employees-search-input" :value="modelValue"
            @input="$emit('update:modelValue', ($event.target as HTMLInputElement).value)"
            placeholder="Поиск сотрудников" aria-label="Поиск сотрудников" maxlength="100">
        <button v-if="modelValue" type="button" class="ds-employees-search-clear" aria-label="Очистить поиск" @click="$emit('clear')">
            <icon width="16" height="16" vb-size="24"><IconClose /></icon>
        </button>
    </label>
</template>

<script setup lang="ts">
import IconClose from '@/ui/icons/IconClose.vue';
import IconSearch from '@/ui/icons/IconSearch.vue'

defineProps({
    modelValue: {
        type: String,
        default: ''
    }
})
defineEmits(['update:modelValue', 'clear'])

</script>
